package lacaravana.ui

import kotlinx.browser.document
import kotlinx.coroutines.launch
import kotlinx.html.*
import kotlinx.html.dom.append
import kotlinx.html.js.onClickFunction
import lacaravana.app.Database
import lacaravana.app.appScope
import lacaravana.domain.Pedido

object CocinaView {
    suspend fun render(db: Database) {
        val content = document.getElementById("content") ?: return
        content.innerHTML = ""
        val items = Pedido.allPendingItems(db)

        content.append {
            h2 { +"Cocina" }
            if (items.isEmpty()) {
                p {
                    id = "cocina-empty"
                    +"Sin pedidos pendientes"
                }
            } else {
                div("cocina-grid") {
                    for (item in items) {
                        div("card cocina-item") {
                            attributes["data-cocina-item"] = item.menuItemNombre
                            attributes["data-estado"] = item.estado
                            h3 { +"${item.menuItemNombre} x${item.cantidad}" }
                            if (!item.notas.isNullOrBlank()) {
                                p { +"Nota: ${item.notas}" }
                            }
                            span("badge badge-${item.estado}") { +item.estado }
                            button {
                                attributes["data-action"] = "advance"
                                val nextLabel = when (item.estado) {
                                    "pendiente" -> "Preparar"
                                    "preparando" -> "Listo"
                                    "listo" -> "Servir"
                                    else -> "—"
                                }
                                +nextLabel
                                onClickFunction = {
                                    appScope.launch {
                                        Pedido.advanceItemEstado(db, item.id)
                                        render(db)
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
